export const STATUS_OK = {
  status: 1
}
export const STATUS_ERROR = {
  status: -6
}
export const PAYMENT_OK = {
  status: 1,
  paymentStatus: 1
}
export const PAYMENT_WAIT = {
  status: 1,
  paymentStatus: 0
}
export const PAYMENT_ERROR = {
  status: 1,
  paymentStatus: -1
}

// USER
export const USER_NOT_LOGGED = {
  status: -12,
  loginUrl: 'https://doladuj.plus.pl/api/plksso/start'
}
export const USER_LOGGED = {
  status: 1,
  logoutUrl: 'https://testdoladuj-plus.autopay.pl/api/test/plksso/end',
  email: 'mac.webcoder@gmail.com',
  firstName: 'Maciej',
  lastName: 'Walczak',
  lastMsisdn: '48790417154',
  lastAmount: 30.00,
  activePaymentMethod: {
    expirationDate: '2022-11-30 23:59',
    cardData: {
      validityYear: '2022',
      validityMonth: '11',
      issuer: 'VISA',
      mask: '4000'
    },
    status: 'ACTIVE'
  },
  activeBlikRecurringPaymentMethod: {
    status: 'ACTIVE'
  },
  regulationsAgreed: true
}
export const USER_LOGGED_NO_CARD = {
  status: 1,
  logoutUrl: 'https://doladuj-plus-test.blue.pl/api/test/plksso/end',
  email: 'mac.webcoder@gmail.com',
  firstName: 'Maciej',
  lastName: 'Walczak',
  lastMsisdn: '48790417154',
  lastAmount: 30.00,
  activePaymentMethod: null,
  regulationsAgreed: false
}
export const USER_NOT_LOGGED_INFO = STATUS_ERROR
export const USER_LOGGED_INFO = {
  status: 1,
  email: 'mac.webcoder@gmail.com'
}
export const USER_UPDATE_SUCCESS = STATUS_OK
export const USER_UPDATE_ERROR = STATUS_ERROR
export const USER_LOGIN_SUCCESS = {
  status: 1,
  userId: 1
}
export const USER_LOGIN_ERROR = STATUS_ERROR
export const USER_LOGOUT_SUCCESS = STATUS_OK
export const USER_LOGOUT_ERROR = STATUS_ERROR
export const USER_REGISTER_SUCCESS = STATUS_OK
export const USER_REGISTER_ERROR = STATUS_ERROR
export const USER_DELETE_SUCCESS = STATUS_OK
export const USER_DELETE_ERROR = STATUS_ERROR
export const USER_ACTIVATE_SUCCESS = STATUS_OK
export const USER_ACTIVATE_ERROR = STATUS_ERROR
export const USER_ACCOUNT_RECOVERY_SUCCESS = STATUS_OK
export const USER_ACCOUNT_RECOVERY_ERROR = STATUS_ERROR
export const USER_ACCOUNT_RECOVERY_CHECK_SUCCESS = STATUS_OK
export const USER_ACCOUNT_RECOVERY_CHECK_ERROR = STATUS_ERROR
export const USER_ACCOUNT_RECOVERY_SET_PASSWORD_SUCCESS = STATUS_OK
export const USER_ACCOUNT_RECOVERY_SET_PASSWORD_ERROR = STATUS_ERROR

// CONTACTS
export const USER_CONTACTS_EMPTY = {
  contacts: [],
  status: 1
}
export const USER_CONTACTS_LIST = {
  contacts: [
    {
      id: 1,
      msisdn: '48601001001',
      description: 'Radek',
      recurringTopup: {
        id: 1,
        day: 90,
        threshold: 20,
        amount: 25,
        recurringTopupType: 'DAY_INTERVAL',
        nextTopupDate: '2020-01-01',
        paymentMethodType: 'BLIK_RECURRING'
      }
    },
    {
      id: 2,
      msisdn: '48602002002',
      description: 'Marek',
      recurringTopup: {
        id: 2,
        day: 25,
        threshold: 10,
        amount: 50,
        recurringTopupType: 'DAY_OF_MONTH',
        nextTopupDate: null,
        paymentMethodType: 'CREDIT_CARD'
      }
    },
    {
      id: 3,
      msisdn: '48603003003',
      description: 'Paweł',
      recurringTopup: null
    }
  ],
  status: 1
}
export const USER_CONTACT_ADD_SUCCESS = {
  contractId: 12,
  status: 1
}
export const USER_CONTACT_ADD_ERROR = {
  contractId: 12,
  status: 1
}
export const USER_CONTACT_UPDATE_SUCCESS = STATUS_OK
export const USER_CONTACT_UPDATE_ERROR = STATUS_ERROR
export const USER_CONTACT_DELETE_SUCCESS = STATUS_OK
export const USER_CONTACT_DELETE_ERROR = STATUS_ERROR

// HISTORY
export const USER_TRANSACTIONS_EMPTY = {
  status: 1,
  transactions: []
}
export const USER_TRANSACTIONS_LIST = {
  status: 1,
  transactions: [
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '1',
      amount: 10.00,
      paymentStatus: 1,
      type: 'SINGLE',
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 1
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '2',
      amount: 10.00,
      paymentStatus: 0,
      type: 'SINGLE',
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '3',
      amount: 10.00,
      paymentStatus: -1,
      type: 'SINGLE',
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: -1
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '4',
      amount: 10.00,
      paymentStatus: 1,
      type: 'RECURRING',
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 1
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '5',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '6',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '7',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '8',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '9',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '10',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '11',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '12',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '13',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '14',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '15',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '16',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-24 12:14',
      orderId: 'YY936PPAM2',
      paymentId: '17',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    },
    {
      date: '2020-09-28 10:27',
      orderId: 'YY936PPHHX',
      paymentId: '18',
      amount: 10.00,
      paymentStatus: 0,
      products: [
        {
          msisdn: '48601001001',
          amount: 10.00,
          status: 0
        }
      ]
    }
  ]
}

// NEWSLETTER
export const NEWSLETTER_UNSUBSCRIBE_SUCCESS = STATUS_OK
export const NEWSLETTER_UNSUBSCRIBE_ERROR = STATUS_ERROR

// PROMO
export const PROMO_GET_FOR_ORDER_SUCCESS = {
  status: 1,
  promoStatus: 1,
  rewardsGranted: 3,
  rewardsLimit: 2,
  email: 'test@autopay.pl'
}
export const PROMO_GET_FOR_ORDER_NO_PROMO = {
  status: 1,
  promoStatus: -2
}
export const PROMO_GET_FOR_ORDER_ERROR = STATUS_ERROR

// PHONE
export const PHONE_CHECKPHONE_SUCCESS = STATUS_OK
export const PHONE_CHECKTOKEN_SUCCESS = STATUS_OK
export const PHONE_TOPUP_SUCCESS = {
  status: 1,
  paymentLink: 'https://testpay.autopay.eu/payment/continue/9I79FVFT/MC7NQKNK',
  orderId: 'YY936PP5F9'
}
export const PHONE_TOPUP_ERROR = STATUS_ERROR

// AUTOTOPUP
export const AUTOTOPUP_ADD_SUCCESS = STATUS_OK
export const AUTOTOPUP_ADD_ERROR = STATUS_ERROR
export const AUTOTOPUP_UPDATE_SUCCESS = STATUS_OK
export const AUTOTOPUP_UPDATE_ERROR = STATUS_ERROR
export const AUTOTOPUP_REMOVE_SUCCESS = STATUS_OK
export const AUTOTOPUP_REMOVE_ERROR = STATUS_ERROR
export const AUTOTOPUP_REGULATIONS = {
  'status': 1,
  'regulations': {
    'id': 123,
    'url': 'https://testpay.autopay.eu/payment'
  }
}

// CREDIT CARD
export const CREDIT_CARD_ADD_SUCCESS = STATUS_OK
export const CREDIT_CARD_ADD_ERROR = STATUS_ERROR
export const CREDIT_CARD_PAYMENT_OK = PAYMENT_OK
export const CREDIT_CARD_PAYMENT_WAIT = PAYMENT_WAIT
export const CREDIT_CARD_PAYMENT_ERROR = PAYMENT_ERROR

// PAYWALL
export const PAYWALL_LIST = {
  'status': 1,
  'gatewayList': [
    {
      'gatewayId': 509,
      'gatewayName': 'BLIK',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/509.png',
      'gatewayType': 'BLIK',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 524,
      'gatewayName': 'BLIK płatność automatyczna',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/509.png',
      'gatewayType': 'BLIK',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1500,
      'gatewayName': 'Płatność kartą',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1500.png',
      'gatewayType': 'CARD',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1808,
      'gatewayName': 'Płatność z ING',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1808.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1800,
      'gatewayName': 'Płatność z mBank',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1800.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1803,
      'gatewayName': 'Płatność z PKOBP',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1803.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1806,
      'gatewayName': 'Płatność z Santander',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1806.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1805,
      'gatewayName': 'Płatność z PekaoSA',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1805.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1807,
      'gatewayName': 'Płatność z Millenium',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1807.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1802,
      'gatewayName': 'Płatność z Alior',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1802.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1809,
      'gatewayName': 'Płatność z Credit Agricole',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1809.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 1064,
      'gatewayName': 'Płacę z Inteligo',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1064.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1804,
      'gatewayName': 'Płatność z BNP Paribas',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1804.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 513,
      'gatewayName': 'Velo Bank',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/513.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 90,
      'gatewayName': 'Płacę z Citi Handlowy',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/90.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 108,
      'gatewayName': 'Pocztowy24',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/108.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 517,
      'gatewayName': 'NestPrzelew',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/517.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 131,
      'gatewayName': 'Płacę z PLUS BANK',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/131.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1813,
      'gatewayName': 'Płać z BOŚ Bank',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1813.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PIS'
    },
    {
      'gatewayId': 98,
      'gatewayName': 'PBS Bank - przelew 24',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/98.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 117,
      'gatewayName': 'Toyota Bank Pay Way',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/117.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1510,
      'gatewayName': 'Bank Spółdzielczy Lututów PBL',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1510.gif',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1515,
      'gatewayName': 'Bank Spółdzielczy w Toruniu PBL',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1515.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1520,
      'gatewayName': 'Bank Spółdzielczy Biała Rawska',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1520.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1519,
      'gatewayName': 'Krakowski Bank Spółdzielczy PBL',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1519.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1522,
      'gatewayName': 'Bank Spółdzielczy Wieliczka PBL',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1522.png',
      'gatewayType': 'PBL',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1523,
      'gatewayName': 'Visa Mobile',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1523.png',
      'gatewayType': 'VISAMOBILE',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1512,
      'gatewayName': 'Google Pay',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1512.png',
      'gatewayType': 'WALLET',
      'confirmationType': 'PLAIN'
    },
    {
      'gatewayId': 1503,
      'gatewayName': 'Kartowa płatność automatyczna',
      'iconUrl': 'https://images.autopay.eu/pomoc/grafika/1503.png',
      'gatewayType': 'AUTO',
      'confirmationType': 'PLAIN'
    }
  ]
}

// AUTOTOPUP ORANGE
export const AUTOTOPUP_ORANGE_CHECKPHONE_SUCCESS = {
  status: 1,
  operator: 'ORANGE'
}
export const AUTOTOPUP_ORANGE_CREATE_SMS_CODE_SUCCESS = {
  status: 1,
  smsCodeId: 1
}
export const AUTOTOPUP_ORANGE_CONFIRM_SMS_CODE_SUCCESS = STATUS_OK
export const AUTOTOPUP_ORANGE_MOBILE_RECURRING_TOPUP_SUCCESS = STATUS_OK

// BLIK
export const BLIK_ADD_SUCCESS = {
  status: 1,
  serviceId: 1000,
  orderId: 123456798,
  hash: 45646465156486465468461564684
}
export const BLIK_ADD_ERROR = {
  status: -171
}

// ESIM
export const ESIM_DESTINATIONS_SUCCESS = [
  {
    'name': 'Europe - global',
    'type': 'GLOBAL'
  },
  {
    'name': 'USA',
    'type': 'COUNTRY'
  },
  {
    'name': 'CHINA',
    'type': 'COUNTRY'
  },
  {
    'name': 'Europe+',
    'type': 'REGION'
  },
  {
    'name': 'Europe',
    'type': 'REGION'
  },
  {
    'name': 'Austria',
    'type': 'COUNTRY'
  }
]
export const ESIM_PACKAGES_SUCCESS = [
  {
    'productId': 'AP_AUSTRIA_30D_3GB',
    'name': 'Austria eSim',
    'iconUrl': 'https://topup.autopay.eu/destination-icon/at.svg',
    'dataQuota': '3072',
    'validityDays': 30,
    'grossPrice': 24.4,
    'destinationType': 'COUNTRY',
    'availableCountries': [
      'Austria'
    ]
  },
  {
    'productId': 'AP_AUSTRIA_15D_3GB',
    'name': 'Austria eSim',
    'iconUrl': 'https://topup.autopay.eu/destination-icon/at.svg',
    'dataQuota': '3072',
    'validityDays': 15,
    'grossPrice': 19.68,
    'destinationType': 'COUNTRY',
    'availableCountries': [
      'Austria'
    ]
  }
]
export const ESIM_START_PAYMENT_SUCCESS = {
  'status': 1,
  'paymentLink': 'https://testpay.autopay.eu/web/payment/continue/AEFU95A5M1/UMB47GKW',
  'orderId': 'YY935QQ1VI'
}

// SIM REGISTER
export const SIM_REGISTER_RESULT = {
  'status': 'OPERATOR_REGISTRATION_ERROR',
  'statusDescription': 'jakis opis',
  'id': 'ac354729-7aa3-4d7f-bcef-7de72e7f774c',
  'timestamp': '2025-04-18T13:10:30.922269226',
  'message': 'Registration not found'
}
